import { createElement, forwardRef, useRef, useState } from 'react';
import { useIsRTL } from '../../../locale';
import { postfixTestId } from '../../../util/testId';
import { ContextMenuButtonProps } from '.';
import { ButtonVariant } from '../../Button';
import { BaseButton } from '../../Button/__internal__';
import { ContextMenu } from '../../ContextMenu';
import { Menu } from '../../Menu';
import { setRef } from '../../../util/ref-util';
import cn from '../../Button/__internal__/BaseButton.css.json';

const longPressThreshold = 750;

export const ContextMenuButton = forwardRef<HTMLButtonElement, ContextMenuButtonProps>(
  (props, ref) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const horizontalAlign = useIsRTL() ? 'start' : 'end';

    const buttonRef = useRef<HTMLButtonElement>(null);
    const timerRef = useRef(-1);

    const openMenu = () => {
      if (!props.disabled) setIsMenuOpen(true);
    };

    return (
      <div>
        <ContextMenu onContextMenu={openMenu}>
          <BaseButton
            ref={(button) => {
              setRef(buttonRef, button);
              setRef(ref, button);
            }}
            disabled={props.disabled}
            testId={props.testId}
            variant={ButtonVariant.Icon}
            className={isMenuOpen ? cn.active : undefined}
            onPress={() => {
              clearTimeout(timerRef.current);
              if (!isMenuOpen) props.onPress?.();
            }}
            onMouseDown={(e) => {
              // left button
              if (e.button === 0) {
                timerRef.current = window.setTimeout(openMenu, longPressThreshold);
              }
            }}
            onMouseLeave={() => {
              clearTimeout(timerRef.current);
            }}
            tooltip={props.tooltip}
            ariaLabel={props.tooltip}
            focusable={props.focusable ?? true}
            icon={props.icon}
          />
        </ContextMenu>
        <Menu
          testId={postfixTestId(props.testId, 'menu')}
          position={{
            dockingElement: buttonRef.current,
            verticalAlign: 'end',
            horizontalAlign,
          }}
          isOpen={isMenuOpen}
          sections={props.sections}
          onItemSelected={(location) => {
            setIsMenuOpen(false);
            buttonRef.current?.focus();
            props.onItemSelected(location);
          }}
          onDismiss={(restoreFocus) => {
            setIsMenuOpen(false);
            if (restoreFocus) buttonRef.current?.focus();
          }}
        />
      </div>
    );
  }
);
